/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_Dates_LabelInputs */

const en_picker_dates_label = /** @type {(inputs: Picker_Dates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dates`)
};

/**
* | output |
* | --- |
* | "Dates" |
*
* @param {Picker_Dates_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_dates_label = /** @type {((inputs?: Picker_Dates_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Dates_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_dates_label(inputs)
});